(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/competition/core/assets/javascripts/competition-signup-helper.js') >= 0) return;  svs.modules.push('/components/competition/core/assets/javascripts/competition-signup-helper.js'); 'use strict';

(function (svs) {
  svs.competition.core.getTipsSMTermsPath = function () {
    var rulesAndTerms = svs.utils.ns.isNamespace('competition.core.data.tipsSMRulesAndTerms.0', svs) ? svs.competition.core.data.tipsSMRulesAndTerms[0] : null;
    return rulesAndTerms ? "/dokument/".concat(rulesAndTerms.documentId) : null;
  };

  svs.competition.core.getTipsSMTermsLink = function () {
    var rulesAndTerms = svs.utils.ns.isNamespace('competition.core.data.tipsSMRulesAndTerms.0', svs) ? svs.competition.core.data.tipsSMRulesAndTerms[0] : null;
    return "<a class=\"message-box-text-link\" href=\"/dokument/".concat(rulesAndTerms.documentId, "\" rel=\"noopener noreferrer\" target=\"_BLANK\">villkor f\xF6r Tips-SM</a>");
  };

  svs.competition.core.acceptTerm = function (term, callback) {
    var termData = {
      id: term.documentId,
      version: term.version.toString(),
      accepted: true
    };
    var options = {
      path: "/player/serviceterms/".concat(term.termType),
      method: 'put',
      data: {
        value: JSON.stringify(termData)
      }
    };
    svs.core.jupiter.call(options, function () {
      callback();
    }, function (error) {
      callback(error);
    });
  }; 


  svs.competition.core.showSignup = function (competition, _callback) {
    if (svs.competition.Helper.userIsParticipatingInTipsSM()) {
      _callback();

      return;
    }

    var termsLink = svs.competition.core.getTipsSMTermsLink();
    svs.components.MessageBox.show({
      title: "Vill du anm\xE4la dig till ".concat(competition.compDesc, "?"),
      message: "Genom att anm\xE4la dig godk\xE4nner du ".concat(termsLink),
      buttons: [{
        type: svs.components.MessageBox.ButtonType.ABORT,
        text: 'Avbryt'
      }, {
        type: svs.components.MessageBox.ButtonType.OK,
        text: 'Anmäl dig',
        callback: function callback() {
          _callback();
        }
      }]
    });
  };

  svs.competition.core.signup = function (options, onSuccess, onError) {
    svs.components.loader.show();
    var signupSteps = [function (callback) {
      svs.competition.core.acceptTerm(options.terms[0], callback);
    }, function (callback) {
      svs.core.jupiter.put({
        path: "/competition/competitions/".concat(options.competition.id, "/participations"),
        data: {
          signupType: 'PARTICIPATE',
          locationId: 0
        }
      }, function () {
        setTimeout(function () {
          svs.competition.core.collections.userCompetitions.fetch();
          callback();
        }, 2000);
      }, function (error) {
        callback(error);
      });
    }];
    async.series(signupSteps, function (error) {
      if (error) {
        onError();
      } else {
        onSuccess();
      }

      svs.components.loader.hide();
    });
  };
})(svs);
 })(window);